import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { from, Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthenticationService } from '../../core/services/authentication.service';
import { EmployeeDateTime } from '../../employee/models/EmployeeDateTime';
import { AttendanceService } from '../../employee/services/attendance.service';
import { SwalHelper } from '../common/SwalHelper';

@Injectable()
export class AttendanceOverflowInterceptor implements HttpInterceptor {
    // intereceptor to handle attendance overflow error

    public urlRegex = /^\/employees\/\d+\/datetimes(?:\/\d+)?\/?$/;

    public constructor(
        private _authService: AuthenticationService,
        private _swalHelper: SwalHelper,
        private _loaderService: NgxUiLoaderService,
        private _translateService: TranslateService,
        private _attendanceService: AttendanceService
    ) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((error) => {
                    const url = '/' + request.url.split('api/')?.[1];
                    if (request.method === 'POST' && this.urlRegex.test(url)) {
                        if (error?.error?.message === 'employees_datetimes.datetime_overflow') {
                            this._loaderService.stopLoader('master');
                            const hasPermission = this._authService.checkPermission('employeeDatetime.edit');
                            return from(this._swalHelper.showConfirmChangeDialog(
                                hasPermission ? 'employees_datetimes.overflow_error_text' : 'employees_datetimes.overflow_error_text_short',
                                'employees_datetimes.overflow_error_title',
                                this.createAdditionalTextHtml(error.error.intersects_with),
                                !hasPermission)
                            )
                                .pipe(
                                    mergeMap((result) => {
                                        const newBody = {...request.body, force_skip_overflow_check: true};
                                        if (result === true) {
                                            return next.handle(request.clone({body: newBody}));
                                        }
                                        this._attendanceService.resetFullCalendarEvents();
                                        return throwError(error);
                                    }));
                        }
                    }

                    return throwError(error);
                }),
            );
    }

    public createAdditionalTextHtml(intersectsWith: EmployeeDateTime[]): string {
        let html = `<h4 class="mt-2 mb-1 font-weight-bold">${this._translateService.instant('employees_datetimes.overflow_intersects_with')}</h4>`;

        intersectsWith.forEach(datetime => {
            const from = moment(datetime.from).format('DD.MM.YYYY');
            const to = moment(datetime.to).format('DD.MM.YYYY');
            html += `<div>${datetime.type.name} ${from} - ${to}</div>`;
        });

        return html;
    }
}
